import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class ApiService {

    inProgress = false;

    constructor(
        protected _http: HttpClient
    ) { }
  
    protected _formParams(data): HttpParams {
        let params: HttpParams = new HttpParams();
    
        if (data !== null && data !== undefined) {
          Object
            .keys(data)
            .filter(key => data[key] !== '')
            .forEach(key => {
              params = params.append(key, typeof data[key] === 'object' ? this._formParams(data[key]) : data[key]);
            });
        }
    
        return params;
    }
    
    request(data: any): Observable<any> {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
          })
        };
    
        this.inProgress = true;
        return new Observable(subscriber => {
          this._http
            .post(data.ajaxUrl, this._formParams(data).toString(), httpOptions)
            .subscribe(
              response => {
                subscriber.next(response);
              },
              error => subscriber.error(error),
              () => {
                this.inProgress = false;
                subscriber.complete();
              }
            );
        });
    }
    
    protected processObject (httpParams, baseKey, object) {
        Object.keys(object).forEach((_key) => {
            if (typeof object[_key] === 'object' && object[_key] !== null && object[_key] !== undefined) {
                httpParams = this.processObject(httpParams, baseKey + '[' + _key + ']', object[_key]);
            } else {
                httpParams = httpParams.append(baseKey + '[' + _key + ']', object[_key]);
            }
        });
    
        return httpParams;
    }
    
    post(url: string, params?: any, noCacheBuster = false, options = null, urlParams: any = null): Observable<any> {
    
        let httpParams = new HttpParams();
        if (params) {
            Object.keys(params).forEach((key) => {
                if (typeof(params[key]) === 'object' && params[key] !== null && params[key] !== undefined) {
                    httpParams = this.processObject(httpParams, key, params[key]);
                } else {
                    httpParams = httpParams.append(key, params[key]);
                }
            });
        }
    
        this.inProgress = true;
        const cacheBuster = (new Date).getTime();
        return new Observable(observer => {
          const addressParams = [];
          if (!noCacheBuster) addressParams.push('t=' + cacheBuster);
          if (urlParams)
          {
            Object.keys(urlParams).forEach(paramKey => {
              if (paramKey && urlParams[paramKey]) addressParams.push(`${paramKey}=${urlParams[paramKey]}`);
            });
          }
          this._http.post(
            `${url}${addressParams.length === 0 ? '' : '?' + addressParams.join('&')}`,
            httpParams,
            options ? options : {}
            )
            .subscribe(
              response => {
                observer.next(response);
              },
              error => {
                observer.error(error);
                this.inProgress = false;
              },
              () => {
                this.inProgress = false;
                observer.complete();
              }
            );
        });
    }
    
    postRaw(url: string, params?: any, noCacheBuster = false, options = null, urlParams: any = null): Observable<any> {
    
        this.inProgress = true;
        const cacheBuster = (new Date).getTime();
        return new Observable(observer => {
          const addressParams = [];
          if (!noCacheBuster) addressParams.push('t=' + cacheBuster);
          if (urlParams)
          {
            Object.keys(urlParams).forEach(paramKey => {
              if (paramKey && urlParams[paramKey]) addressParams.push(`${paramKey}=${urlParams[paramKey]}`);
            });
          }
          this._http.post(
            `${url}${addressParams.length === 0 ? '' : '?' + addressParams.join('&')}`,
            params,
            options ? options : {}
          )
            .subscribe(
              response => {
                observer.next(response);
              },
              error => {
                observer.error(error);
                this.inProgress = false;
              },
              () => {
                this.inProgress = false;
                observer.complete();
              }
            );
        });
    }
    
    get(url: string, params?: any, headers?: any): Observable<any> {
    
        let httpParams = new HttpParams();
        if (params) {
            Object.keys(params).forEach((key) => {
                if (typeof(params[key]) === 'object' && params[key] !== null && params[key] !== undefined) {
                    httpParams = this.processObject(httpParams, key, params[key]);
                } else {
                    httpParams = httpParams.append(key, params[key]);
                }
            });
        }
    
        this.inProgress = true;
        const cacheBuster = (new Date).getTime();
        const options: {
          params?: any;
          headers?: any;
        } = {
          params: httpParams
        };
        if (headers) options.headers = headers;
        return new Observable(observer => {
          this._http.get(`${url}?t=${cacheBuster}`, options)
            .subscribe(
              response => {
                observer.next(response);
              },
              error => {
                observer.error(error);
                this.inProgress = false;
              },
              () => {
                this.inProgress = false;
                observer.complete();
              }
            );
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/auto-loans/api.service.ts